import React from "react";
import sbimg from "../Scholarship/sbimg.png";
import { Divider } from "@chakra-ui/react";
import { IoSchool, IoHome } from "react-icons/io5";
import { AiOutlineLogout } from "react-icons/ai";
import { useNavigate } from 'react-router-dom'; 
import { useToast } from '@chakra-ui/react'

function Sidebar() {
  const navigate=useNavigate()
  const toast = useToast() 

    const handleLogout = () => {
      // Remove the token from localStorage
      localStorage.removeItem('sbpathshalaAdmin');
      toast({
        title: 'Logout',
        description: "",
        status: 'success',
        duration: 2000,
        isClosable: true,
        position: 'bottom-center',
      })
      navigate("/")
     
    }

  return (
    <div
      style={{
        width: "100%",
      height:"100vh",
        backgroundColor: "#56636A",
        paddingTop: "10px",
       
      }}
    >
      <img src={sbimg} alt="Sb" style={{ borderRadius: "100%" }} />
      <Divider h="2px" color="black" bgColor="black" mt="10Px" />
      <div style={{ display: "flex", justifyContent: "center" }}>
      <a href={`${process.env.REACT_APP_FRONTEND_URL}/teachers/dashboard`}>
        <IoHome style={{ fontSize: "3em", color: "white" }} />
        </a>
      </div>
      <Divider h="2px" color="black" bgColor="black" mt="10Px" />
      <div style={{ display: "flex", justifyContent: "center" }} >
      <a href={`${process.env.REACT_APP_FRONTEND_URL}/teachers/dashboard/scholarship`}>
        <IoSchool style={{ fontSize: "3em", color: "white" }} />
        </a>
      </div>

      <Divider h="2px" color="black" bgColor="black" mt="10Px" />
      <div style={{ display: "flex", justifyContent: "center" }}>
        <AiOutlineLogout style={{ fontSize: "3em", color: "white" }} onClick={handleLogout}/>
      </div>
      <Divider h="2px" color="black" bgColor="black" mt="10Px" />
    </div>
  );
}

export default Sidebar;
